"use strict";

var _interopRequireDefault = require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _slicedToArray2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/slicedToArray.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    isExternalLink: function isExternalLink(routePath) {
      return (0, _utils.isExternal)(routePath);
    },
    linkProps: function linkProps(url) {
      if (this.isExternalLink(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        };
      }
      var queryParams = this.urlToJson(url);
      if (url.indexOf('?') !== -1) {
        url = url.split('?')[0];
      }
      var link1 = {
        is: 'router-link',
        to: {
          path: '/redirect' + url,
          // 原有 redirect 路径
          query: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.$route.query), queryParams)
        }
      };
      // console.log('url', url, link1)
      return link1;
    },
    urlToJson: function urlToJson(url) {
      // 1. 截取 URL 中 ? 后的 query 部分（无参数则返回空对象）
      var queryStr = url.split('?')[1] || '';
      if (!queryStr) return {};

      // 2. 分割参数（& 分隔），遍历解析为键值对
      var jsonObj = {};
      queryStr.split('&').forEach(function (item) {
        // 处理 key=value 格式（兼容空值，如 isNew=、name=）
        var _item$split = item.split('='),
          _item$split2 = (0, _slicedToArray2.default)(_item$split, 2),
          key = _item$split2[0],
          value = _item$split2[1];
        if (key) {
          // 解码 URL 编码（如空格、中文），并处理值类型
          var decodedValue = decodeURIComponent(value || '');
          // 自动转换数字/布尔值（可选，根据需求）
          if (/^\d+$/.test(decodedValue)) {
            jsonObj[key] = Number(decodedValue); // 数字
          } else if (decodedValue === 'true' || decodedValue === 'false') {
            jsonObj[key] = decodedValue === 'true'; // 布尔值
          } else if (decodedValue === 'null') {
            jsonObj[key] = null; // null
          } else {
            jsonObj[key] = decodedValue; // 字符串
          }
        }
      });
      return jsonObj;
    }
  }
};